import { render, staticRenderFns } from "./CheckBillsStatus.vue?vue&type=template&id=5467c642&scoped=true&"
import script from "./CheckBillsStatus.vue?vue&type=script&lang=js&"
export * from "./CheckBillsStatus.vue?vue&type=script&lang=js&"
import style0 from "./CheckBillsStatus.vue?vue&type=style&index=0&id=5467c642&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5467c642",
  null
  
)

export default component.exports